import { MicrosoftXboxControllerOffIcon } from './MicrosoftXboxControllerOffIcon';

/**
 * author: Austin Andrews
 * id F73FF165-CE6C-4E27-B492-93F3B82C70EE
 * name microsoft-xbox-controller-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microsoft-xbox-controller-off.svg
 * tags
 * - Gaming / RPG 
 */
export const MicrosoftXboxGamepadOffIcon = MicrosoftXboxControllerOffIcon;
export default MicrosoftXboxGamepadOffIcon